import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyChMJQE3Ghh4JDvk1h6nAav8iQ93lsDnL4",
    authDomain: "wedding-bartek.firebaseapp.com",
    projectId: "wedding-bartek",
    storageBucket: "wedding-bartek.firebasestorage.app",
    messagingSenderId: "804263612351",
    appId: "1:804263612351:web:c771a232740c651e2adb0a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db      = getFirestore(app);
export const storage = getStorage(app);
export const auth    = getAuth(app);